module.exports = __webpack_public_path__ + "static/media/ic_vibration_move.b9a69fc5.svg";